import React from "react";
import MUIButton, { ButtonProps } from "@mui/material/Button";

interface PrimaryButtonProps extends ButtonProps{
  addStyle?: string;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  secondary?: boolean;
  // ... any other props you'd like to pass to the button
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  addStyle,
  children,
  onClick,
  disabled,
  secondary=false,
  ...otherProps
}) => {
  // Define default styles and conditional styles based on props
  const defaultStyles = {
    fontFamily: "Inter, sans-serif",
    borderRadius: "2px",
    backgroundColor: "#0093C8",
    color: "white",
    fontSize: "14px",
    fontWeight: 600,
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 2px 3px 0px",
  };

  const secondaryStyles = {
    fontFamily: "Inter, sans-serif",
    borderRadius: "2px",
    backgroundColor: "#FFFFFF",
    color: "#0093C8",
    fontSize: "14px",
    fontWeight: 600,
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 2px 3px 0px",
    border: "solid #0093C8 1px"
  }

  const disabledStyles = {
    backgroundColor: "#F4F8F9",
    color: "#9EACB4",
    boxShadow: "none",
    border: "none",
  };

  return (
    <MUIButton
      sx={{
        ...defaultStyles,
        ...(secondary ? secondaryStyles : {}),
        ...(disabled ? disabledStyles : {}),

        "&:hover": {
          backgroundColor: secondary ? "#F4F8F9" : "#0093C8",
          boxShadow: "rgba(0, 0, 0, 0.25) 0px 2px 3px 0px",
        },

        "&.Mui-disabled": disabledStyles,
      }}
      onClick={onClick}
      disabled={disabled}
      {...otherProps}
      className={addStyle}>
      {children}
    </MUIButton>
  );
};

export default PrimaryButton;
